"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./TextAndButtonModalFooter.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TextAndButtonModalFooter = function TextAndButtonModalFooter(_ref) {
  var _ref$footerText = _ref.footerText,
      footerText = _ref$footerText === void 0 ? 'Footer Text' : _ref$footerText,
      _ref$buttonText = _ref.buttonText,
      buttonText = _ref$buttonText === void 0 ? 'Close' : _ref$buttonText,
      _ref$buttonAction = _ref.buttonAction,
      buttonAction = _ref$buttonAction === void 0 ? function () {} : _ref$buttonAction;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "text-and-button-modal-footer"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "footer-text"
  }, footerText), /*#__PURE__*/_react.default.createElement("button", {
    onClick: buttonAction,
    className: "footer-button"
  }, buttonText));
};

var string = _propTypes.default.string,
    func = _propTypes.default.func;
TextAndButtonModalFooter.propTypes = {
  footerText: string,
  buttonText: string,
  buttonAction: func
};
var _default = TextAndButtonModalFooter;
exports.default = _default;